import React from "react";
import "../style/link.scss";
import Krug from "./Krug";

export default function LinkButton({ buttonText, link }) {
  return (
    <a className="link-btn" href={link}>
      {buttonText} <Krug />
    </a>
  );
}
